"use client";

import { createContext, useContext } from "react";
import type { AuthBackendId } from "@/lib/authBackend/types";

/** Context value: "amplify" | "trimble". Defaults to "trimble" */
export const AuthBackendContext = createContext<AuthBackendId>("trimble");

export function useAuthBackendId(): AuthBackendId {
  return useContext(AuthBackendContext);
}

/**
 * Whether the auth-backend decision is final. Trimble is the only backend now, so this
 * is always `true`; the context remains until its consumers are collapsed.
 */
export const AuthBackendReadyContext = createContext<boolean>(true);

export function useAuthBackendReady(): boolean {
  return useContext(AuthBackendReadyContext);
}
